module.exports = __webpack_public_path__ + "img/money_small.82c5f3c2.svg";